<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-10 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <div class="border rounded">
                  <div class="row">
                    <div class="col-12">
                      <p class="p-brown px-4 pt-4">
                        اگرشخصی که بدحجاب است وشما اورا می شناسید وشما یقین دارید اگر در موقعیتی قراربگیرد کشف حجاب
                        میکند، آیا پلاک ماشینش را ثبت می کنید؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            خیر
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            شاید
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            احتمالاً
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        کدام مورد از نگاه طرح ناظر جهت ثبت پلاک، کشف حجاب محسوب میشود؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بدحجابی شدید
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            روسری نصفه بر روی سر باشد
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            روسری کاملا بر روی سر نباشد
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            موارد ب و ج
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        درکدام موارد زیر ثبت پلاک انجام می دهید؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            پلاک مخدوش است اما رنگ ونوع ماشین درست است
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            پلاک ورنگ ومدل ماشین تطبیق ندارد
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            پلاک واضح است، بارنگ ومدل ماشین تطبیق ندارد
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            پلاک واضح است، بارنگ ومدل ماشین تطبیق دارد
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        اگر کشف حجاب را خودتان نبینید ولی یکی از دوستان یا یک نفر مورد اعتماد به شما پلاکی بدهد ثبت می کنید؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            هرکسی پلاک بدهد ثبت می کنم
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            فقط اگر افراد خیلی مورد اعتماد بدهند ثبت می کنم
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            به هیچ وجه ثبت نمیکنم
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            موارد الف وب
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        در ثبت کشف حجاب کدام مورد اهمیت اساسی دارد؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            زمان ومکان دقیق
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            ثبت دقیق پلاک وتطبیق آن با مدل ورنگ ماشین
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            یقین به کشف حجاب
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            همه موارد
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        کدام یک از موارد زیر، تبعات احتمالی ثبت اشتباه کشف حجاب محسوب می شود؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            دعوای بین زن و شوهر
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            مشکلات بین پدر و پسر
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            مشکلات بین دوستان
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            همه موارد
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        اگر فقط از پشت سر دیدید شخصی کشف حجاب کرده، باید پلاکش را ثبت کنیم؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، چون مشخص است که کشف حجاب انجام شده
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            خیر، چون شاید آن فرد آقا باشد
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، چون به احتمال خیلی زیاد آن شخص خانم است
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، فکر کردن ندارد
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        اگر دیدید خانمی کشف حجاب کرده و شما ثبت پلاک کردید، و بعد از یک ساعت باز آن شخص را در همان حال دیدید، آیا میتوانید پلاکش را دوباره ثبت کنید؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، چون کشف حجاب کرده
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، چون یک ساعت از ثبت پلاک قبلی گذشته
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، چون اگر آدم فهمیده ای بود گوش میکرد
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            خیر، چون در سامانه ناظر نمیشود در یک روز برای یک پلاک، دوبار کشف حجاب ثبت کرد
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        اگر دیدید خانمی کشف حجاب کرده و شما ثبت پلاک کردید، و بعد از یک ساعت باز آن شخص را در همان حال دیدید، آیا میتوانید پلاکش را روز بعد، دوباره ثبت کنید؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، چون کشف حجاب کرده
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، چون یک روز از ثبت پلاک قبلی گذشته
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله، چون اگر آدم فهمیده ای بود گوش میکرد
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            خیر، چون از نظر سامانه ناظر این کار درست نیست و ثبت پلاک در هر روز از یک ماشین فقط یک بار و در همان روز انجام میشود
                          </label>
                        </div>
                        <hr>
                      </div>
                      <p class="p-brown px-4 pt-4">
                        اگر خانمی خیلی خیلی بد حجاب بود که از نگاه شما، این تیپ زدن آن شخص، حداقل مثل کشف حجاب بود، آیا میشود ثبت پلاک کرد؟
                      </p>
                      <br/>
                      <div class="px-4">
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1" checked>
                          <label class="form-check-label-radio" for="exampleRadios1">
                            خیر
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            بله
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            شاید
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1"
                                 value="option1">
                          <label class="form-check-label-radio" for="exampleRadios1">
                            احتمالاً
                          </label>
                        </div>
                        <hr>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <RouterLink to="/rule-tutorial" class="bbot mx-auto">
                    ▶ صفحه قبل
                  </RouterLink>
                  <RouterLink to="/faq" class="bbot mx-auto">
                    ثبت
                  </RouterLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamRuleView"
}
</script>

<style scoped>
.form-check {
  display: flex;
  justify-content: flex-start;
}

.form-check-label-radio {
  margin-right: 40px;
  font-weight: bold;
}

</style>